import React from "react";
import { useUrlLocale } from "../../../hooks/useUrlLocale";

interface Props {}

const LOCALES = [
  {
    id: "sk",
    title: "Slovensky"
  },
  {
    id: "en",
    title: "English"
  },
  {
    id: "de",
    title: "Deutsch"
  }
];
export const LocaleLinks: React.FC<Props> = props => {
  const localeId = useUrlLocale();
  return (
    <>
      {LOCALES.filter(locale => locale.id !== localeId).map(
        (locale, idx, coll) => (
          <React.Fragment key={locale.id}>
            <a
              style={{ color: "inherit", textDecoration: "none" }}
              href={`/${locale.id}`}
            >
              {locale.title}
            </a>
            {isLast(idx, coll) ? null : (
              <div style={{ padding: "0 10px" }}>•</div>
            )}
          </React.Fragment>
        )
      )}
    </>
  );
};

function isLast<T>(idx: number, arr: T[]): boolean {
  return idx + 1 === arr.length;
}
